const MuiFormControl = {
  root: {
    width: '100%',
    padding: '0 8px'
  }
}

export default MuiFormControl
